import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-container',
  templateUrl: './container.component.html',
  styleUrls: ['./container.component.scss']
})
export class ContainerComponent implements OnInit {


  version=environment.VERSION
  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  getFondo(){
    if (this.router.url === '/mopa' || this.router.url === '/mopa/home') {

      return  'linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),url(/assets/PTicon.svg) no-repeat center';
    }
    return ""
  }
}
